// extracted by mini-css-extract-plugin
export default {"box":"header-module--box--892bb","content":"header-module--content--0ac9b","close":"header-module--close--963f1"};